import styled from 'styled-components';

const LinearProgressMLStyled = styled.div`
  .bar {
    background: ${(props) => props.color};
  }
`;
export default LinearProgressMLStyled;
